import PropTypes from "prop-types";
import * as React from "react";

import { reject } from "../../../../../Common/TypingUtils";

import { UnitId } from "./UnitId/UnitId";

type GetUnitIdCallback = () => UnitId;

const UnitIdContextObject = React.createContext<GetUnitIdCallback | undefined>(undefined);

export function useGetUnitId(): GetUnitIdCallback {
    return React.useContext(UnitIdContextObject) ?? reject("GetUnitId is not provided");
}

export interface UnitIdContext {
    getUnitId: GetUnitIdCallback;
}

export const unitIdContentTypes = {
    getUnitId: PropTypes.func,
};

interface GetUnitIdProviderProps extends UnitIdContext {
    children: React.ReactNode;
}

/**
 * @summary
 * Кастомные контролы достают GetUnitId через старый контекст
 */
export class GetUnitIdProvider extends React.Component<GetUnitIdProviderProps> {
    public static childContextTypes = unitIdContentTypes;

    public getChildContext(): UnitIdContext {
        return {
            getUnitId: () => this.props.getUnitId(),
        };
    }

    public override render(): JSX.Element {
        return (
            <UnitIdContextObject.Provider value={this.props.getUnitId}>
                {this.props.children}
            </UnitIdContextObject.Provider>
        );
    }
}

interface UnitIdProviderProps {
    id: UnitId;
    children: React.ReactNode;
}

export function UnitIdProvider(props: UnitIdProviderProps): JSX.Element {
    const getUnitId = React.useCallback(() => props.id, [props.id]);

    return <GetUnitIdProvider getUnitId={getUnitId}>{props.children}</GetUnitIdProvider>;
}
